import { render, staticRenderFns } from "./BusinessObjEnts.vue?vue&type=template&id=460213fc&scoped=true&"
import script from "./BusinessObjEnts.vue?vue&type=script&lang=js&"
export * from "./BusinessObjEnts.vue?vue&type=script&lang=js&"
import style0 from "./BusinessObjEnts.vue?vue&type=style&index=0&id=460213fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460213fc",
  null
  
)

export default component.exports